import React, { Component } from "react";
import ReactDOM from "react-dom";

import { Layout, Menu, Spin } from 'antd';
import Burger from '@animated-burgers/burger-slip';
import '@animated-burgers/burger-slip/dist/styles.css';
import classNames from 'classnames';

import MainFooter from "./containers/Footer";
import { Redirect } from 'react-router-dom';

import MainPage from './pages/Main';
import TermsConditionPage from './pages/TermsCondition';
import PrivacyPoliciesPage from './pages/PrivacyPolicies';
import CookiesPoliciesPage from './pages/CookiesPolicies';
import RCMPage from "./pages/RCM";
import SpeakersPage from './pages/Speakers';
import PlayerPage from './pages/Player';
import RegisterPage from './pages/Register';
import SchedulePage from './pages/Schedule';
import LoginPage from './pages/Login';
import LivePollResults from './pages/LivePollResults';

import Cookies from './containers/Cookies';
import GA from './components/Utils/GoogleAnalytics.js'

import Core from './Core';
import { getSocket, initSocket } from './socket';


import './App.scss';

import { UserOutlined } from '@ant-design/icons';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

const { Header, Content, Footer } = Layout;
const { SubMenu } = Menu;

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      loginLogoutTick: 0,
      defaultSelectedMenu: 'main',
      burgerMenu: false,
      width: 0,
      height: 0,
      accepted: sessionStorage.getItem('cookies-accepted'),
      cookiesHeight: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.handleLogged = this.handleLogged.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.onClickAcceptCookies = this.onClickAcceptCookies.bind(this);
    this.setCookiesHeight = this.setCookiesHeight.bind(this);
    Core.onLogged = this.handleLogged;
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    if (window.location.pathname == '/') {
      this.setState({ defaultSelectedMenu: 'main' });
    } else {
      this.setState({ defaultSelectedMenu: 'none' });
    }
    if (Core.data().login && getSocket() == null) {
      initSocket(Core.data().login);
    }
    Core.menu.click = this.onMenuClick;
    this.loadConfig();
  }

  componentDidUpdate(prevProps, prevState) {
    console.log(window.location.pathname.toUpperCase());
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    Core.menu.click = () => { };
  }

  onClickAcceptCookies() {
    sessionStorage.setItem('cookies-accepted', '1');
    this.setState({ accepted: '1' });
    this.setCookiesHeight(0);
  }

  setCookiesHeight(e) {
    this.setState({ cookiesHeight: e + "px" });
  }

  updateWindowDimensions() {
    const { burgerMenu } = this.state;
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
      burgerMenu: window.innerWidth > 800 ? false : burgerMenu
    });
  }

  onMenuClick(selectedMenu) {
    let { defaultSelectedMenu } = this.state;
    if (selectedMenu) {
      defaultSelectedMenu = selectedMenu;
    }
    this.setState({ burgerMenu: false, defaultSelectedMenu });
    window.scrollTo(0, 0);
  }


  loadConfig() {
    Core.apiData(`config.json`, {
      onSuccess: (data) => {
        if (data.json) {
          Core.data().config = data.json;
          document.title = data.json.site_title;
          this.setState({ loaded: true });
        } else {
          this.setState({ loaded: false });
          console.log("Config data is not a JSON!", data);
        }
      },
      onFail: (data) => {
        this.setState({ loaded: false });
        console.log("Config data failed!", data);
      }
    });
  }

  handleLogged() {
    const { loginLogoutTick } = this.state;
    this.setState({ loginLogoutTick: loginLogoutTick + 1 });
  }

  handleLogout() {
    const { loginLogoutTick } = this.state;
    Core.data().login = null;
    sessionStorage.clear();
    this.setState({ loginLogoutTick: loginLogoutTick + 1 });
    window.location.assign("/")
  }

  render() {
    const { burgerMenu, defaultSelectedMenu, loaded, logout } = this.state;
    if (loaded == false) {
      return (
        <Layout>
          <div className="loading">
            <Spin size="large" />
            <h1>A carregar...</h1>
          </div>
        </Layout>
      );
    }

    console.log("Core Data: ");
    console.log(Core.data());

    return (
      <Router>
        { GA.init() && <GA.RouteTracker />}
        <div className="page">
          <Layout>
            {(!Core.data().config.private || window.location.pathname.toUpperCase() !== '/LOGIN') ?
              <Header className={classNames({ 'header-burger-open': burgerMenu })}>
                {(window.location.pathname.toUpperCase() !== '/POLITICA-DE-COOKIES' &&
                  window.location.pathname.toUpperCase() !== '/POLITICA-DE-PRIVACIDADE') &&
                  <h1 className="header-title">
                    <Link to="/" onClick={() => this.onMenuClick('main')}>
                      <img src="/data/images/logo.png" />
                    </Link>
                  </h1>
                }
                <div className="header-burger">
                  <Burger isOpen={burgerMenu} onClick={() => { this.setState({ burgerMenu: !burgerMenu }); }} />
                </div>
                <div className={
                  classNames({
                    'menu': true,
                    'menu-burger-open': burgerMenu
                  })
                }>
                  <Menu
                    theme="dark"
                    mode={burgerMenu ? 'vertical' : 'horizontal'}
                    defaultSelectedKeys={[defaultSelectedMenu]}
                    selectedKeys={[defaultSelectedMenu]}>
                    {Core.data().config.no_home == false ?
                      <Menu.Item key="main"><Link to="/" onClick={() => this.onMenuClick('main')}>Home</Link></Menu.Item>
                      : null}
                    {Core.data().config.speakers == true ?
                      <Menu.Item key="speakers"><Link to="/speakers" onClick={() => this.onMenuClick('speakers')}>Oradores</Link></Menu.Item>
                      : null}
                    {Core.data().config.schedules == true ?
                      <Menu.Item key="programa"><Link to="/programa" onClick={() => this.onMenuClick('programa')}>Agenda</Link></Menu.Item>
                      : null}
                    {(Core.data().config.login == true || Core.data().login) && Core.data().config.no_home == false ?
                      <Menu.Item key="player" className="player-menu" ><Link to="/player" onClick={() => this.onMenuClick('player')}>Evento</Link></Menu.Item> : null}
                    {Core.data().config.login == true || Core.data().config.register == true ?
                      <SubMenu className="right-input profile" title={<UserOutlined className="site-form-item-icon" />}>
                        {Core.data().config.login == true ? (
                          Core.data().login ?
                            <Menu.Item key="logout"><a onClick={this.handleLogout}>Logout</a></Menu.Item>
                            : <Menu.Item key="login"><Link to="/login" onClick={() => this.onMenuClick('login')}>Login</Link></Menu.Item>
                        ) : null}
                        {Core.data().config.register == true && Core.data().config.email_only == false ?
                          <Menu.Item key="registo"><Link to="/registo" onClick={() => this.onMenuClick('registo')}>Registo</Link></Menu.Item>
                          : null}
                      </SubMenu>
                      : null}
                    <Menu.ItemGroup title="Perfil" className="profile-mobile">
                      {Core.data().login ?
                        <Menu.Item key="logout"><a onClick={this.handleLogout}>Logout</a></Menu.Item>
                        : <Menu.Item key="login"><Link to="/login" onClick={() => this.onMenuClick('login')}>Login</Link></Menu.Item>}
                      {Core.data().config.register == true ?
                        <Menu.Item key="registo"><Link to="/registo" onClick={() => this.onMenuClick('registo')}>Registo</Link></Menu.Item>
                        : null}
                    </Menu.ItemGroup>
                  </Menu>
                </div>
              </Header>
              : null}
            <Content style={{ paddingBottom: this.state.cookiesHeight }}>
              <Switch>
                <Route path="/termos-e-condicoes" component={TermsConditionPage} />
                <Route path="/politica-de-privacidade" component={PrivacyPoliciesPage} />
                <Route path="/rcm" component={RCMPage} />
                <Route path="/politica-de-cookies" component={CookiesPoliciesPage} />
                {Core.data().config.speakers == true ?
                  <Route path="/speakers" component={SpeakersPage} />
                  : null}
                <Route path="/player" component={PlayerPage} />
                {Core.data().config.register == true ?
                  <Route path="/registo" component={RegisterPage} />
                  : null}
                {Core.data().config.schedules == true ?
                  <Route path="/programa" component={SchedulePage} />
                  : null}
                <Route path="/livePollResults" component={LivePollResults} />
                <Route path="/login/:token?" component={LoginPage} />
                <Route path="/" component={MainPage} />
              </Switch>
            </Content>
            {(!Core.data().config.private && this.state.accepted || window.location.pathname.toUpperCase() !== '/LOGIN' && this.state.accepted) ?
              <MainFooter />
              : null}
          </Layout>
        </div>
        <Cookies accepted={this.state.accepted} setCookiesHeight={(e) => this.setCookiesHeight(e)} onClick={this.onClickAcceptCookies} />
      </Router>
    );
  }
}
